<div class="main-container">
  <div class="demo-center">
    <div class="text-content">
      <h1>{{'registrationDemoLandingPage.title1'|cxTranslate}}</h1>
      <p>{{'registrationDemoLandingPage.p1'|cxTranslate}}</p>
      <p>{{'registrationDemoLandingPage.p2'|cxTranslate}}
        <!-- <a [routerLink]="['/']"
          class="tech-headings">{{'registrationDemoLandingPage.Currently_no_demos'|cxTranslate}}</a> -->
        <a [routerLink]="['/myDemoRegistration/form']"
          class="tech-headings">{{'registrationDemoLandingPage.resgister'|cxTranslate}} </a>
        {{'registrationDemoLandingPage.today'|cxTranslate}}
      </p>
    </div>
    <div class="right">

      <h3 class="text-blue font-22 mb-8">{{'registrationDemoLandingPage.p3'|cxTranslate}}</h3>

      <p class="mb-8">{{'registrationDemoLandingPage.p4'|cxTranslate}}</p>
      <p class="text-blue font-22 mb-8">{{'registrationDemoLandingPage.Bendix_in_action'|cxTranslate}}</p>
      <div class="bendix-video-section mb-8">
        <a href="https://www.youtube.com/watch?v=76PBqPnTuLs" target="_blank" rel="noopener noreferrer"
          class="video-link">
          <cx-page-slot position="Section5" class="bendix-video-banner"></cx-page-slot>
        </a>
      </div>
      <ul>
        <li><a class="tech-headings">
            <strong>{{'registrationDemoLandingPage.list_title1'|cxTranslate}}</strong></a>
          {{'registrationDemoLandingPage.list_desc1'|cxTranslate}}
        </li>

        <li><a class="tech-headings">
            <strong>{{'registrationDemoLandingPage.list_title2'|cxTranslate}}</strong></a>
          {{'registrationDemoLandingPage.list_desc2'|cxTranslate}} </li>

        <li><a class="tech-headings"><strong>{{'registrationDemoLandingPage.list_title3'|cxTranslate}}
            </strong></a> {{'registrationDemoLandingPage.list_desc3'|cxTranslate}}</li>

        <li><a class="tech-headings"><strong>{{'registrationDemoLandingPage.list_title4'|cxTranslate}}</strong></a>
          {{'registrationDemoLandingPage.list_desc4'|cxTranslate}}</li>

      </ul>
    </div>

    <div class="image-content">
      <!--   <a [routerLink]="['/']"> -->
      <a [routerLink]="['/myDemoRegistration/form']">
        <cx-page-slot position="SideContentB" class="img-safety-systems-demonstration-icon"></cx-page-slot>
        <button class="register_today_btn">
          {{'registrationDemoLandingPage.register_here'|cxTranslate}}
          <!--  {{'registrationDemoLandingPage.Currently_no_demos'|cxTranslate}} -->
        </button>
      </a>
    </div>

  </div>
</div>